import CustomZObject from "./CustomZObject.js";

export default class JGraphics extends CustomZObject {
    constructor(zobject) {
        super(zobject);
        this.color = '#A19A9A';
        this.backgroundColor = '#100B0B';
        this.fillColor = '#757474';
        this.dotColor = '#B5B5B5';
        this.newInlet("color", (msg) => {
            this.color = msg[0];
        });
        this.newInlet("backgroundColor", (msg) => this.backgroundColor = msg[0]);
        this.newInlet("fillColor", (msg) => this.fillColor = msg[0]);
        this.newInlet("dotColor", (msg) => this.dotColor = msg[0]);
    }
}
